(() => {
  const root = document.querySelector('[data-dx]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-dx-config]').textContent);
  const R = cfg.root || '/';
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = matchMedia('(pointer: fine)').matches;
  const $ = (s, c = root) => c.querySelector(s);
  const $$ = (s, c = root) => [...c.querySelectorAll(s)];
  const T = (s) => (window.__dxDict && window.__dxDict[s]) || s;
  const esc = (s) => String(s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]);

  // ---------- Tee illustration ----------
  function tee(side) {
    const front = side === 'front';
    return `<svg viewBox="0 0 400 440" aria-hidden="true">
      <path d="M92 72 L58 92 L16 372 L58 382 L94 168 Z" fill="#0a0a0a"/>
      <path d="M308 72 L342 92 L384 372 L342 382 L306 168 Z" fill="#0a0a0a"/>
      <path d="M16 372 L58 382 L56 396 L14 386 Z" fill="#262626"/>
      <path d="M384 372 L342 382 L344 396 L386 386 Z" fill="#262626"/>
      <path d="M92 72 L150 48 Q200 ${front ? 84 : 60} 250 48 L308 72 L308 410 L92 410 Z" fill="#fff" stroke="#0a0a0a" stroke-width="3" stroke-linejoin="round"/>
      <path d="M150 48 Q200 ${front ? 84 : 60} 250 48" fill="none" stroke="#0a0a0a" stroke-width="8" stroke-linecap="round"/>
      ${front
        ? '<g fill="#0a0a0a"><rect x="138" y="140" width="124" height="16" rx="2"/><rect x="152" y="166" width="96" height="16" rx="2"/><rect x="130" y="192" width="140" height="16" rx="2"/></g>'
        : '<rect x="188" y="78" width="24" height="9" rx="1" fill="#0a0a0a" opacity=".75"/>'}
      <path d="M94 398 L306 398" stroke="#0a0a0a" stroke-width="1.5" stroke-dasharray="4 4"/>
    </svg>`;
  }

  // ---------- 3D viewer ----------
  $$('[data-tee3d]').forEach((el) => {
    el.innerHTML = `<div class="dx-stage__toggle" role="group" aria-label="View side">
        <button type="button" aria-pressed="true" data-side="0">${T('Front')}</button>
        <button type="button" aria-pressed="false" data-side="180">${T('Back')}</button></div>
      <div class="dx-3d"><div class="dx-3d__inner">
        <div class="dx-3d__face">${tee('front')}</div>
        <div class="dx-3d__face dx-3d__face--back">${tee('back')}</div></div></div>
      <p class="dx-stage__hint">${T('Drag to rotate')}</p>`;
    const wrap = $('.dx-3d', el);
    const inner = $('.dx-3d__inner', el);
    let rot = 0, startX = null, base = 0;
    const apply = (extraY = 0, tiltX = 0) => {
      inner.style.transform = `rotateX(${tiltX}deg) rotateY(${rot + extraY}deg)`;
      const f = (((rot % 360) + 360) % 360);
      const back = f > 90 && f < 270;
      $$('[data-side]', el).forEach((b) => b.setAttribute('aria-pressed', String((b.dataset.side === '180') === back)));
    };
    $$('[data-side]', el).forEach((b) => b.addEventListener('click', () => {
      rot = Math.round(rot / 360) * 360 + Number(b.dataset.side);
      apply();
    }));
    wrap.addEventListener('pointerdown', (e) => {
      startX = e.clientX; base = rot;
      inner.classList.add('is-drag');
      wrap.setPointerCapture(e.pointerId);
    });
    wrap.addEventListener('pointermove', (e) => {
      if (startX === null) {
        if (!FINE || RM) return;
        const r = wrap.getBoundingClientRect();
        apply(((e.clientX - r.left) / r.width - 0.5) * 18, ((e.clientY - r.top) / r.height - 0.5) * -10);
        return;
      }
      rot = base + (e.clientX - startX) * 0.6;
      apply();
    });
    const end = () => {
      if (startX === null) return;
      startX = null;
      inner.classList.remove('is-drag');
      rot = Math.round(rot / 180) * 180;
      apply();
    };
    wrap.addEventListener('pointerup', end);
    wrap.addEventListener('pointercancel', end);
    wrap.addEventListener('pointerleave', () => { if (startX === null) apply(); });
    apply();
  });

  // ---------- Hero ----------
  const hero = $('[data-hero]');
  if (hero) {
    const t = $('[data-split]', hero);
    const txt = t.textContent.trim();
    t.setAttribute('aria-label', txt);
    t.innerHTML = [...txt].map((c) => (c === ' ' ? '<span class="sp"></span>' : `<span class="ch" aria-hidden="true">${esc(c)}</span>`)).join('');
    const chars = $$('.ch', t);
    if (FINE && !RM) {
      hero.addEventListener('pointermove', (e) => {
        const r = hero.getBoundingClientRect();
        const x = e.clientX - r.left;
        hero.style.setProperty('--x', `${x}px`);
        hero.style.setProperty('--y', `${e.clientY - r.top}px`);
        chars.forEach((c) => {
          const cr = c.getBoundingClientRect();
          const k = Math.max(0, 1 - Math.abs(cr.left + cr.width / 2 - e.clientX) / 260);
          c.style.transform = `translateY(${-k * 26}px) scaleY(${1 + k * 0.12})`;
        });
      });
      hero.addEventListener('pointerleave', () => chars.forEach((c) => { c.style.transform = ''; }));
    }
  }

  if (FINE && !RM) {
    $$('[data-magnetic]').forEach((b) => {
      b.addEventListener('pointermove', (e) => {
        const r = b.getBoundingClientRect();
        b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.25}px, ${(e.clientY - r.top - r.height / 2) * 0.35}px)`;
      });
      b.addEventListener('pointerleave', () => { b.style.transform = ''; });
    });
  }

  // ---------- Marquee: speed and direction follow scrolling ----------
  const mq = $('[data-marquee] .dx-marquee__track');
  if (mq && !RM) {
    let x = 0, dir = 1, boost = 0, last = scrollY;
    const loop = () => {
      const dy = scrollY - last;
      last = scrollY;
      if (dy) dir = dy > 0 ? 1 : -1;
      boost = Math.max(boost * 0.92, Math.min(Math.abs(dy) * 0.4, 14));
      x -= (0.6 + boost) * dir;
      const half = mq.scrollWidth / 2;
      if (half) { if (x <= -half) x += half; if (x > 0) x -= half; }
      mq.style.transform = `translate3d(${x}px,0,0)`;
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }

  // ---------- Reveal on scroll ----------
  const io = new IntersectionObserver((entries) => entries.forEach((e) => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  }), { threshold: 0.15 });
  $$('[data-reveal], .dx-tl').forEach((el) => io.observe(el));

  window.__dx = { root, cfg, R, RM, FINE, $, $$, esc, tee, T };
})();